import { assertIsoDate } from "./dates";

export function parseGermanDate(s: string): string {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(s.trim());
  if (!m) {
    throw new Error(`Invalid German date: ${s}`);
  }
  const [, dd, mm, yyyy] = m;
  return assertIsoDate(`${yyyy}-${mm}-${dd}`);
}

export function parseGermanAmount(s: string): number {
  return Number(s.trim().replace(/\./g, "").replace(",", "."));
}
